// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"60":"teren-map","371":"iconify-collection","550":"teren-graph"}[chunkId] || chunkId) + "-" + __webpack_require__.h() + ".js";
};